<template>
  <div itemscope itemtype="http://schema.org/ItemList" class="books-lister row">
    <div
      v-for="(book, index) in books"
      :key="book.title"
      class="book col-md-4 mb-32"
      itemscope
      itemprop="itemListElement"
      itemtype="http://schema.org/ListItem"
    >
      <span class="d-none" itemprop="position" :content="index" />
      <NuxtLink
        :to="`/boek/${book.slug}`"
        itemprop="url"
        class="book__cover__anchor"
      >
        <div :ref="book.slug" class="book__cover__wrapper mb-md-16">
          <BookCover
            :cover="book.cover"
            :title="book.title"
            :genres="book.genres"
          />
        </div>
      </NuxtLink>

      <div>
        <NuxtLink :to="`/boek/${book.slug}`" class="reset-link-styling">
          <div v-if="book.averageRating" class="mb-16">
            <StarsRating :rating="book.averageRating" />
          </div>

          <h4 class="book__title">
            {{ book.title }}
          </h4>

          <span
            v-if="book.author"
            class="d-block mb-8"
            data-testid="book-author"
          >
            {{ book.author.name }}
          </span>

          <small v-if="book.genres" class="book__genre text-small">
            {{ book.genres.join(', ') }}
          </small>
        </NuxtLink>
      </div>
    </div>
  </div>
</template>

<!-- eslint-disable no-empty -->
<script>
import BookCover from '~/components/books/BookCover'
import StarsRating from '~/components/reviews/StarsRating'
import { scrollIntoView } from '~/utils/index'

export default {
  components: {
    BookCover,
    StarsRating
  },
  props: {
    books: {
      type: Array,
      required: true
    },
    routeFrom: {
      type: [Object, undefined],
      default: undefined
    }
  },
  mounted() {
    try {
      const prevPage = this.routeFrom

      if (prevPage && prevPage.name === 'boek-slug') {
        setTimeout(() => this.scrollToBook(prevPage.params.slug), 50)
      }
    } catch {}
  },
  methods: {
    scrollToBook(slug) {
      try {
        const elements = this.$refs[slug]

        if (elements && elements[0] && window.scrollY === 0) {
          scrollIntoView(elements[0], {}, 32)
        }
      } catch {}
    }
  }
}
</script>
